import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  empresa: null,
  isAuthenticated: false,
};

export const authenticationSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action) => {
      state.user = action.payload;
      state.isAuthenticated = true;
    },
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
    },
  },
});

export const { login, logout } = authenticationSlice.actions;
export default authenticationSlice.reducer;